const menu = [
  {
    id: 1,
    title: 'buttermilk pancakes',
    category: 'breakfast',
    price: 15.99,
    img: './images/item-1.jpeg',
    desc: `Fluffly pancakes served with unclarified and unsalted butter and maple syrup on top `,
  },
  {
    id: 2,
    title: 'diner double',
    category: 'lunch',
    price: 13.99,
    img: './images/item-2.jpeg',
    desc: `Double patty cheese burger with fries in side, served with garlic butter `,
  },
  {
    id: 3,
    title: 'godzilla milkshake',
    category: 'dessert',
    price: 6.99,
    img: './images/item-3.jpeg',
    desc: `Chilled strawberry flavoured milkshake in a milk jar with strawberry donuts on top`,
  },
  {
    id: 4,
    title: 'country delight',
    category: 'breakfast',
    price: 20.99,
    img: './images/item-4.jpeg',
    desc: `Classic sunshine eggs with hashbrown and black coffee  `,
  },
  {
    id: 5,
    title: 'egg attack',
    category: 'lunch',
    price: 22.99,
    img: './images/item-5.jpeg',
    desc: `Classical Cheeseburger with eggs in between `,
  },
  {
    id: 6,
    title: 'oreo dream',
    category: 'dessert',
    price: 18.99,
    img: './images/item-6.jpeg',
    desc: `A super easy milkshake made with vanilla ice cream, milk, and Oreo cookies`,
  },
  {
    id: 7,
    title: 'bacon overflow',
    category: 'breakfast',
    price: 8.99,
    img: './images/item-7.jpeg',
    desc: `This easy-to-make sandwich is made using easily available ingredients. `,
  },
  {
    id: 8,
    title: 'american classic',
    category: 'lunch',
    price: 12.99,
    img: './images/item-8.jpeg',
    desc: `No description for this classic, seriously, none, you should know...  `,
  },
  {
    id: 9,
    title: 'quarantine buddy',
    category: 'dessert',
    price: 16.99,
    img: './images/item-9.jpeg',
    desc: `Discover love with our new shake, comes with social distance masks too xD`,
  },
  {
    id: 10,
    title: 'Butter Paneer with Naan',
    category: 'lunch',
    price: 16.99,
    img: './images/item-11.jpg',
    desc: `Rich & creamy curry made with paneer, spices, onions, tomatoes, cashews and butter, served with Naan{Flat Bread}`,
  },
  {
    id: 11,
    title: 'Shwarma Chicken Gyro',
    category: 'lunch',
    price: 16.99,
    img: './images/item-12.jpg',
    desc: `Middle Eastern cuisine consisting of meat cut into thin slices, stacked in a cone-like shape, and roasted on a slowly-turning vertical rotisserie`,
  },
  {
    id: 12,
    title: 'Energy Meal',
    category: 'breakfast',
    price: 16.99,
    img: './images/item-19.jpg',
    desc: `Plate full of berries, jam, and pancakes. Elites don't want you to know this, but it'll make your day much better.`,
  },
  {
    id: 13,
    title: 'Penne Pasta',
    category: 'lunch',
    price: 16.99,
    img: './images/item-14.jpg',
    desc: `Penne pasta, mozzarella cheese, grape tomatoes, parmesan`,
  },
  {
    id: 14,
    title: 'Beese Churger',
    category: 'lunch',
    price: 16.99,
    img: './images/item-15.jpg',
    desc: `beesechurger. A glitch in the Matrix. We have no  idea how it's here, but it is.`,
  },
  {
    id: 15,
    title: 'black forest cake',
    category: 'dessert',
    price: 16.99,
    img: './images/item-16.jpg',
    desc: `Layers of chocolate sponge cake, cherries, and whipped cream. It is frosted with whipped cream and covered with chocolate shavings and a few cherries for decoration`,
  },
  {
    id: 16,
    title: 'Avocado Toast',
    category: 'breakfast',
    price: 16.99,
    img: './images/item-20.jpg',
    desc: `Mashed avocado, spinach on top of wheat bread toasts, can this get anymore healthier? topped with generous amount of poached egg and chilli flakes `,
  },
]
export default menu
